import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, DatePicker, Checkbox} from 'antd'
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import FromInput from '../../../../components/user/from/Input'
import InputDateStartEnd from '../../../../components/user/from/InputDateStartEnd'
import { checkType } from '../../../../utils/checkType'
import { pushAge, pushAgeWork, changeFormatdate } from '../../../../utils/formatdate'
import { numberWithCommas } from '../../../../utils/number'
import { checkStatus } from '../../../../utils/hospital'
import ModalConfirmForm from '../../../../components/user/ModalConfirmForm'
import moment from 'moment'
import { alertMessage } from '../../../../utils/message'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;

const newsDataProfile = '';

class ConfirmCreate extends Component {
	state = {
		loading:false,
		dataTalbe: [],
        columns: [
            {
                title:  () =>{ 
							return <Checkbox 
									// className="checkBox-select"
									disabled={ this.state.selectStatus == 'PENDING' ? false : true }
									checked={ this.state.checkBoxTitle }
									onChange={
										(e) => this.onChangeSlectAll(e.target.checked)}
									>
								</Checkbox>
				},
                dataIndex: 'statusCheckBox',
                width:'10px',
				align:'center',
                render: (item, record, index) => { 
                    return 	<Checkbox 
								// className="checkBox-select"
								disabled={ this.state.selectStatus == 'PENDING' ? false : true }
								checked={item} 
                                onChange={
                                    (e) => this.onChangeSlectTable(e.target.checked, record.wdHospitalId,record.isPension,record.empAffiliationOrgCode, index, record)}
                                >
                            </Checkbox>
                }
            },
			{
                title: 'เลขที่สารบรรณ',
                dataIndex: 'refDocument',
				width:'125px',
				align:'center',
                render: (item, record, index) => <div style={{ width:"90px", wordWrap:"break-word" }}><span>{ item }</span></div>
            },
            {
                title: 'เลขที่เอกสาร',
                dataIndex: 'withdrawNo',
                width:'90px',
				align:'center',
                render: (item, record, index) => <span>{ item }</span>
            },
			{
                title: 'ชื่อบุคลากร',
                dataIndex: 'empFirstName',
				align:"center",
                width:'200px',
				render: (item, record, index) => <span>{record.empFirstName+' '+record.empLastName}</span>
            },
			{
                title: 'ชื่อผู้เบิก',
                dataIndex: 'withdrawFirstName',
				align:"center",
                width:'200px',
				render: (item, record, index) => <span>{record.withdrawFirstName+' '+record.withdrawLastName}</span>
            },
			{
                title: 'สำนัก',
                dataIndex: 'orgName',
                width:'200px',
                align:'center',
                // sorter: (a, b) => a.orgCode - b.orgCode,
                render: (item, record, index) => <span>{ record.orgCode }  { item } </span>
            },
			{
                title: 'ป่วยเป็นโรค',
                dataIndex: 'sicknessName',
                width:'200px',
				align:"center",
				render: (item, record, index) => <span>{ item }</span>
            },
			{
                title: 'จำนวนเงินในใบเสร็จ',
				// align:'right',
				align:"center",
                width:'100px',
                dataIndex: 'totalWithdraw',
                render: (item, record, index) => <div  align="right"><span>{ item ? numberWithCommas(item) : '' }</span></div>
            },
			{
                title: 'จำนวนเงินที่เบิกได้ทั้งหมด',
				align:'center',
                dataIndex: 'totalCurrentWithdraw',
                width:'100px',
				align:"right",
                render: (item, record, index) => <div align="right"><span>{item ? numberWithCommas(item) : 0}</span></div>
            },
			{
                title: 'วันที่ยื่นเรื่อง',
				align:'center',
                width:'150px',
                dataIndex: 'date',
                render: (item, record, index) => <span>{changeFormatdate(item)}</span>
            },
			{
                title: 'วันที่สร้างเอกสาร',
				align:'center',
                width:'150px',
                dataIndex: 'createdAt',
                render: (item, record, index) => <span>{changeFormatdate(item)}</span>
            },
			{
                title: 'สถานะ',
                dataIndex: 'status',
				align:"center",
                width:'150px',
                render: (item, record, index) => <span>{checkStatus(item)}</span>
            },
            {
                title: 'จัดการ',
                dataIndex: '7',
                width:'120px',
				align:'center',
                render: (item, record, index) => {
                    return <>
						<Link
							to={{
								pathname: '/hospital/Confirm/'+record.wdHospitalId+'/'+record.status
							}}
						>
                       		<Icon type="form" className="mr-2"/>
					   </Link>
					   {/* <Popconfirm placement="topRight" title={"คุณต้องการที่จะลบ"} onConfirm={ () => this.delectField('1')} okText="ตกลง" cancelText="ยกเลิก">
						   <Icon type="delete"/>
						</Popconfirm> */}
                    </>
                }
            },
        ],
		pageData: {
            offset: 0,
            limit: 10
        },
        pagination: {
            total: 10,
        },
        disabledDateStart:null,
        dataSelectTable:[],
		disabledDateStart:moment().add(-30, 'days'),
		endStartValues:moment(),
		ModalConfirmFormTitle:null,
        ModalConfirmFormSubTitle:null,
        ModalConfirmFormShowModal:false,
        ModalConfirmFormBtnOk:null,
        ModalConfirmFormBtnCancel:null,
        ModalConfirmFormValue:null,
        ModalConfirmFormStatus:null,
		ModalConfirmFormMessage:null,
		selectStatus:"PENDING",
		checkBoxTitle: false,
		ModalFormTextArea:false,
        ModalFormTextAreaRequie: false,
		showExportApprove: false
	}

	delectField = (id) =>{
		alert('test')
	}


	clearInput = async () =>{
		this.props.form.resetFields();
		
	}

	onChangeValueDateStart = async (e) =>{

		// this.form.resetFields('endDate')
		await this.setState({
			 disabledDateStart: moment(e),
		})

		await this.props.form.setFieldsValue({
			endDate: '',
		})
	 }

	 onChangeValueDateEnd = async (e) =>{
		await this.setState({
			endDate: moment(e),
		})
	}
 
	 disabledDate = (current) =>{
		 const { disabledDateStart } = this.state
		 return current && current < disabledDateStart;
	 }

	 onChangeSlectAll = async (value) =>{
		const { dataTalbe } = this.state
		let arrayNewsDataTable = []
		const rowsDataSelectTable = []
		const rows = null
		if(value){
			await dataTalbe.map((values, keys)=>{
				values.statusCheckBox = value
				arrayNewsDataTable[keys] = values
				rowsDataSelectTable.push({
							wdHospitalId: values.wdHospitalId,
                            totalCurrentWithdraw: values.totalCurrentWithdraw,
							isPension: values.isPension,
							isJuristic: values.isJuristic,
							
							// accountName: values.isJuristic == 2 ? values.accountName : "",
							// accountNo: values.isJuristic == 2 ? values.accountNo : "",
							// bankBranchCode:values.isJuristic == 2 ? values.bankBranchCode : "",
							// bankBranchName: values.isJuristic == 2 ? values.bankBranchName : "",
							// bankCode: values.isJuristic == 2 ? values.bankCode : "",
							// bankName:values.isJuristic == 2 ? values.bankName : "",
							hospitalBankDetail: values.isJuristic == 1 ? values.hospitalBankAccountId : null,
							// relationship: values.isJuristic == 2 ? values.relationship : "",
							// remarkForPay: values.isJuristic == 2 ? values.remarkForPay : "",
							empAffiliationOrgCode: values.empAffiliationOrgCode,
						})
			})
		}else{
			await dataTalbe.map((values, keys)=>{
				values.statusCheckBox = value
				arrayNewsDataTable[keys] = values
			})
		}


		await this.setState({
			dataTalbe: arrayNewsDataTable,
			dataSelectTable:rowsDataSelectTable,
			checkBoxTitle:value
		}, () => {
                this.setSummary()
                // this.cllBackSetValueOrganizatuions()
            })
		
	}
     
    onChangeSlectTable = async(values, wdHospitalId,isPension, empAffiliationOrgCode, arrayId, record) =>{
        let dataSourceitems = [...this.state.dataSelectTable];
        let keysdataSelectTable = null

        let dataSourceitemsTable = [...this.state.dataTalbe];
        let item = {...dataSourceitemsTable[arrayId]};
        item.statusCheckBox = values

        dataSourceitemsTable[arrayId] = item;

        await this.setState({
            dataTalbe:dataSourceitemsTable
        },() => {
            // this.cllBackSetValueContactNumber()
        })

        dataSourceitems.map(async(filtereditem, keys) =>{
            if(filtereditem.wdHospitalId == wdHospitalId){
                keysdataSelectTable = keys
            }
        })

        if(values){
            const rows = {
                	wdHospitalId: wdHospitalId,
					isPension: isPension,
					empAffiliationOrgCode: empAffiliationOrgCode,
					isJuristic: record.isJuristic,
					// accountName: record.isJuristic == 2 ? record.accountName : "",
					// accountNo: record.isJuristic == 2 ? record.accountNo : "",
					// bankBranchCode:record.isJuristic == 2 ? record.bankBranchCode : "",
					// bankBranchName: record.isJuristic == 2 ? record.bankBranchName : "",
					// bankCode: record.isJuristic == 2 ? record.bankCode : "",
					// bankName:record.isJuristic == 2 ? record.bankName : "",
					hospitalBankAccountId: record.isJuristic == 1 ? record.hospitalBankAccountId : null,
					// relationship: record.isJuristic == 2 ? record.relationship : "",
					// remarkForPay: record.isJuristic == 2 ? record.remarkForPay : "",
				// name: record.name,
				// age: record.age,
				// address: record.address,
                // status:true,
                // money: record.money
            }
            await this.setState(prevState => ({
                dataSelectTable: [...prevState.dataSelectTable, rows],
            }), () => {
                this.setSummary()
                // this.cllBackSetValueOrganizatuions()
            })
        }else{
            dataSourceitems.filter(item => item.wdHospitalId == wdHospitalId).map((filtereditem) => {
                var arrayDataSource = [...this.state.dataSelectTable];
                    arrayDataSource.splice(keysdataSelectTable, 1);
                    
                    this.setState({
                        dataSelectTable:arrayDataSource,
						checkBoxTitle: false
                    },() => {
                        this.setSummary()
                    // this.cllBackSetValueContactNumber()
                    })
            })
        }
    }

    setSummary = async () =>{
        const { dataSelectTable } = this.state

        let totalMoney = 0;
                                
        dataSelectTable.forEach(({ money }) => {
            totalMoney += parseFloat(money);
        });    

        await this.setState({
            summaryTotal:totalMoney
        })
    }

	handleSubmit = async (e) => {
        const { form, afterSubmit, client } = this.props
        const { telNo, otpToken, refCode, selectStatus } = this.state
		await e.preventDefault()
		form.validateFields(async (err, values) => {
			await this.setState({
				formValue: e
			})

			// await this.searchListWdHospital(values)
			console.log('fsdasfs',values)
			if (!err) {
                try {
					const { data, errors } = await client.query({
						query: Queries.fetchListSearchWDHospitalApprover,
                        variables: {
                            ...values
                        }
					})

					await this.setState({
						selectStatus: values.status
					})
					
                    if(data.fetchListWDHospitalApprover){
						let dataTalbeArray = []

						data.fetchListWDHospitalApprover.map((valuesList, keys) =>{
							valuesList.statusCheckBox = false
							dataTalbeArray.push(valuesList);
						})
			
						// console.log('dataTalbeArray',dataTalbeArray)
						await this.setState({
							dataTalbe: dataTalbeArray,
							preLoadSubmit:false,
							loading:false
						})

						if(selectStatus == 'APPROVE'){
							await this.setState({
								showExportApprove: true
							})
						}else{
							await this.setState({
								showExportApprove: false
							})
						}
						// await this.setState({
						// 	dataTalbe: data.fetchListSearchWDHospitalApprover
						// })
					}else{
						await this.setState({
							dataTalbe: []
						})
					}
                }catch (error) {
					console.log('error',error)
                }
			}
		})
	}

	fetchListWDHospitalApprover =  async() =>{
		const { client,location ,match } = this.props
		const { offset ,limit, disabledDateStart, endDate } = this.state
		
		let dataTalbeArray = []

		await this.setState({
			preLoadSubmit:true,
			loading:true
		})

		const { data, errors } = await client.query({
			query: Queries.fetchListSearchWDHospitalApprover,
			variables: {
				status:"PENDING"
				// startDate: disabledDateStart,
				// endDate: endDate,
			}
		})

		console.log('datasssss',data)

		if(data.fetchListWDHospitalApprover){
			data.fetchListWDHospitalApprover.map((valuesList, keys) =>{
				valuesList.statusCheckBox = false
				dataTalbeArray.push(valuesList);
			})

			// console.log('dataTalbeArray',dataTalbeArray)
			await this.setState({
				dataTalbe: dataTalbeArray,
				preLoadSubmit:false,
				loading:false
			})
		}else{
			await this.setState({
				preLoadSubmit:false,
				loading:false
			})
		}
	}

	hideModalConfirm = async () =>{
        await this.setState({
            ModalConfirmFormTitle:null,
            ModalConfirmFormSubTitle:null,
            ModalConfirmFormShowModal:false,
            ModalConfirmFormBtnOk:null,
            ModalConfirmFormBtnCancel:null,
            ModalConfirmFormValue:null,
            ModalConfirmFormStatus:null,
			ModalConfirmFormMessage:null
        })
    }

    showModalFormConfirm = async (status, messageForm, title , textBtnOK, ModalFormTextArea, ModalFormTextAreaRequie) =>{
        const { form, client } = this.props
		const { dataSelectTable } = this.state
        
        this.setState({
            preLoadOnsubmit: true
        })

		if(dataSelectTable.length !== 0){
			await this.setState({
				ModalConfirmFormTitle:title,
				ModalConfirmFormSubTitle:'',
				ModalConfirmFormShowModal:true,
				ModalConfirmFormBtnOk:textBtnOK,
				ModalConfirmFormBtnCancel:'ยกเลิก',
				ModalConfirmFormValue:{},
				ModalConfirmFormStatus:status,
				ModalConfirmFormMessage: messageForm,
				ModalFormTextArea,
        		ModalFormTextAreaRequie
			})
		}else{
			let content = ''
			// message.warning('กรุณาเลือกเอกสาร อย่างน้อย 1 รายการ');
			if(status == 'REJECT'){
				content = 'กรุณาเลือกเอกสารที่ไม่อนุมัติรายการขอเบิก'
			}else if(status == 'APPROVE'){
				content = 'กรุณาเลือกเอกสารที่จะทำการอนุมัติรายการขอเบิก'
			}else if(status == 'MOREINFO'){
				content = 'กรุณาเลือกเอกสารที่จะทำการขอเอกสารเพิ่มเติมรายการขอเบิก'
			}

			alertMessage("warning",content)

			// message.warning({
			// 	content: content,
			// 	key:'1',
			// 	duration: 3,
			// })
		}
   }

	fetchCountListAllApproving = async () =>{
		const { client } = this.props
		const { data } = await client.query({
			query: Queries.fetchCountListAllApproving,
		})

		sessionStorage.setItem('totalLeaveCount', data.fetchCountListAllApproving.leaveCount);
		sessionStorage.setItem('totalWdHospitalCount', data.fetchCountListAllApproving.wdHospitalCount);

		if(document.getElementById('value-LeaveCount-title').getElementsByClassName('ant-scroll-number-only-unit current')[0]){
			document.getElementById('value-LeaveCount-title').getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = parseInt(data.fetchCountListAllApproving ? data.fetchCountListAllApproving.leaveCount : 0);
		}

		// if(document.getElementById('value-LeaveCount-subtitle').getElementsByClassName('ant-scroll-number-only-unit current')[0]){
		// 	document.getElementById('value-LeaveCount-subtitle').getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = parseInt(data.fetchCountListAllApproving ? data.fetchCountListAllApproving.leaveCount : 0);
		// }

		if(document.getElementById('value-wdHospital-title').getElementsByClassName('ant-scroll-number-only-unit current')[0]){
			document.getElementById('value-wdHospital-title').getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = parseInt(data.fetchCountListAllApproving ? data.fetchCountListAllApproving.wdHospitalCount : 0);
		}

		// if(document.getElementById('value-wdHospital-subtitle').getElementsByClassName('ant-scroll-number-only-unit current')[0]){
		// 	document.getElementById('value-wdHospital-subtitle').getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = parseInt(data.fetchCountListAllApproving ? data.fetchCountListAllApproving.wdHospitalCount : 0);
		// }
	}

	setToApprover = async (status) =>{
		try {
			const { form, afterSubmit, client } = this.props
			const { dataSelectTable, ModalConfirmFormMessage, ModalConfirmFormStatus } = this.state
	
			let constSelect = dataSelectTable.length
			let errorOccurred = false;
			
			for (let keys = 0; keys < dataSelectTable.length; keys++) {
				const valuesSelect = dataSelectTable[keys];
				console.log("valuesSelect dd", valuesSelect);
				const resultUpdate = await client.mutate({
					mutation: Mutations.updateWDHospital,
					variables: {
						wdHospitalId: valuesSelect.wdHospitalId,
						status: ModalConfirmFormStatus,
						isPension: valuesSelect.isPension ? valuesSelect.isPension : false,
						empAffiliationOrgCode: valuesSelect.empAffiliationOrgCode,
						isJuristic: valuesSelect.isJuristic,
						// accountName: valuesSelect.accountName,
						// accountNo: valuesSelect.accountNo,
						// bankBranchCode: valuesSelect.bankBranchCode,
						// bankBranchName: valuesSelect.bankBranchName,
						// bankCode: valuesSelect.bankCode,
						// bankName: valuesSelect.bankName,
						hospitalBankAccountId: valuesSelect.hospitalBankAccountId ? valuesSelect.hospitalBankAccountId : null,
						// relationship: valuesSelect.relationship,
						// remarkForPay: valuesSelect.remarkForPay,						
					}
				});
			
				if (resultUpdate.data.updateWDHospital == null) {
					errorOccurred = true
					alertMessage("error", "พบเอกสารไม่ถูกต้อง กรุณาตรวจสอบเอกสารใหม่อีกครั้ง");
					break;
				} else {
					if (constSelect - 1 == keys) {
						alertMessage("success", ModalConfirmFormMessage);
						await this.setState({
							dataSelectTable: [],
						});
						await this.hideModalConfirm();
						await this.fetchListWDHospitalApprover();
					}
				}
			}
			if (errorOccurred) {
				setTimeout(() => {
					window.location.reload();
				}, 2000)
			}
		} catch(err) {
			console.log('in catch error')
			alertMessage("error", "Failed Catch")
		}
	}

	submitReject = async () =>{
		await this.showModalFormConfirm(
					'REJECT', 
					'ไม่อนุมัติรายการขอเบิกที่เลือกเรียบร้อย', 
					'ท่านไม่อนุมัติการเบิกค่ารักษาพยาบาล ด้วยสาเหตุใด?', 
					'ยืนยัน',
					true,
					true,
				)
	}

	submitApprover = async () =>{
		await this.showModalFormConfirm(
						'APPROVE', 
						'ทำการอนุมัติรายการขอเบิกที่เลือกเรียบร้อย', 
						'ยืนยันอนุมัติการขอเบิกค่ารักษาพยาบาล?', 
						'อนุมัติ',
						false,
						false
					)
	}

	submitMoreinfo = async () =>{
		await this.showModalFormConfirm(
						'MOREINFO', 
						'ทำการขอเอกสารเพิ่มเติมรายการขอเบิกที่เลือกเรียบร้อย', 
						'ขอเอกสารเพิ่มเติมของการเบิกรักษาพยาบาล?', 
						'ขอเอกสารเพิ่มเติม'
					)
	}

	onChangeStatus = async (e) =>{
		await this.setState({
			selectStatus: e,
			checkBoxTitle:false
		})

		await this.onChangeSlectAll(false)
	}

	fetchProfile = async () => {
		try {
			const { client } = this.props
			const { data } = await client.query({
				query: Queries.fetchProfile
			})

			console.log('data.fetchProfile',data.fetchProfile)
			// data.fetchProfile.isEmployeeApprover = false
			// if(data.fetchProfile){
				await this.setState({ 
					empCode: data.fetchProfile.employeeCodes[0]
					// consent: data.fetchProfile.consent,
					// profile: data.fetchProfile,
					// imageContent:data.fetchProfile.imageContent
				})

			// 	console.log('sss',data.fetchProfile)
				
			// 	// return data.fetchProfile
			// }else{
			// 	return null
			// }
			
		} catch (e) {
			// message.error('Something went wrong. Please try again')
		}
	}


	fetchUrlWDHospitalApproverPDFReport = async () =>{
		const { client } = this.props
		const { empCode } = this.state
		const { data } = await client.query({
			query: Queries.fetchUrlWDHospitalApproverPDFReport,
			variables: {
				empCode
			}
		})

		if(data.fetchUrlWDHospitalApproverPDFReport){
			if(data.fetchUrlWDHospitalApproverPDFReport.linkPDF){
				window.open(data.fetchUrlWDHospitalApproverPDFReport.linkPDF, '_blank');
			}
		}
	}

	async componentDidMount(){
		await this.fetchListWDHospitalApprover()
		await this.fetchProfile()
    }

	render() {
		const { match } = this.props
		const { 
			dataTalbe, 
			columns, 
			loading, 
			pagination, 
			valuesEndDate, 
			disabledDateStart, 
			endStartValues,
			dataSelectTable,
			preLoadSubmit,
			ModalConfirmFormTitle,
         ModalConfirmFormSubTitle,
         ModalConfirmFormShowModal,
         ModalConfirmFormBtnOk,
         ModalConfirmFormBtnCancel,
         ModalConfirmFormValue,
			ModalFormTextArea,
        	ModalFormTextAreaRequie,
			showExportApprove,
			selectStatus
		} = this.state
		const { getFieldDecorator } = this.props.form;
        // console.log('dataSelectTable', dataSelectTable)
        console.log('dataTalbe', dataTalbe)
		return (
			<Container match={match}>
				<div className="breadcrumb-custom pb-3 mb-5">
                    {/* <Breadcrumb.Item> */}
                        <span style={{ fontSize:"18px" }}>การเบิกค่ารักษาพยาบาล / รายการอนุมัติ</span>
                    {/* </Breadcrumb.Item> */}
                </div>
				 <ModalConfirmForm 
                    title={ModalConfirmFormTitle} 
                    subtitle={ModalConfirmFormSubTitle}
                    showModal={ModalConfirmFormShowModal} 
                    btnOk={ModalConfirmFormBtnOk} 
                    btnCancel={ModalConfirmFormBtnCancel}  
                    submitToSend={ this.setToApprover }
                    hideModal={ this.hideModalConfirm }
                    valueConfirm = { ModalConfirmFormValue }
					ModalFormTextArea = {ModalFormTextArea}
                    ModalFormTextAreaRequie = {ModalFormTextAreaRequie}
                />
				<div className="card-container" id="page-profile">
					<div className="px-5 py-1 card-bg-green">
						<Form onSubmit={this.handleSubmit}>
							<Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
								<Col xs={24} md={24} className="pt-2 mb-4">
									<strong className="color-red">
										ค้นหา
									</strong>
								</Col>

								<Col xs={24} md={12}>
                                    <Form.Item label={"ค้นหา"}>
                                        { getFieldDecorator("searchKeyword", {
                                            initialValue: '',
                                            rules:  [{ 
                                                required:false, 
                                            }],
                                        })(
                                            <Input 
                                                className='block-news' 
                                            />
                                        )}
                                    </Form.Item>
                                </Col>

								<Col xs={ 24 } md={12} >
									<Form.Item label={"สถานะ"}>
										{ getFieldDecorator("status", {
											initialValue: "PENDING",
											rules:  [{ 
												message: 'กรุณากรอกหรือเลือก สถานะ',
											}],
										})(
											<Select 
												style={{ width: "100%" }} 
												onChange={ (e) => this.onChangeStatus(e) }
											>
												<Option value="ALL">ทั้งหมด</Option>
												<Option value="APPROVE">อนุมัติ</Option>
												<Option value="PENDING">รออนุมัติ</Option>
												<Option value="REJECT">ไม่อนุมัติ</Option>
												<Option value="MOREINFO">ขอเอกสารเพิ่มเติม</Option>
												<Option value="RETURN">ส่งคืน Maker</Option>
												<Option value="PAID">รอโอนเงิน</Option>
												<Option value="SUCCESS">ดำเนินการเสร็จสิ้น</Option>
												<Option value="EDIT">แก้ไข</Option>
												<Option value="FAILED">โอนเงินไม่สำเร็จ (รอจ่ายเงินสด)</Option>
												<Option value="DRAFT">แบบร่าง</Option>
												<Option value="CANCEL">คืนเงินให้คลัง</Option>
												<Option value="CASH">จ่ายเงินสด</Option>
												<Option value="CANCELDOC">ยกเลิกเอกสาร</Option>
												<Option value="PAIDCASH">รับเป็นเงินสด</Option>
											</Select>
										)}
									</Form.Item>
								</Col>
								
								{/* <Col xs={ 24 } md={8}>
									<Form.Item label="วันที่ขอเบิก" className="mb-0">
										{ getFieldDecorator('startDate', {
											initialValue: disabledDateStart,
											rules:  [{ 
												required:false,
												message: 'กรุณากรอกหรือเลือก วันที่ขอเบิก',
											}],
										})(
											<DatePicker 
												className="w-100"  
												placeholder="เลือกวันที่" 
												onChange={(e) => this.onChangeValueDateStart(e)}
												allowClear={false}
											/>
										)}
									</Form.Item>
								</Col>
								
								<Col xs={ 24 } md={8}>
									<Form.Item label="วันที่สิ้นสุดขอเบิก" className="mb-0">
										{ getFieldDecorator('endDate', {
											initialValue: endStartValues,
											rules:  [{ 
												required:false,
												message: 'กรุณากรอกหรือเลือก วันที่สิ้นสุดขอเบิก',
											}],
										})(
											<DatePicker 
												disabledDate={this.disabledDate} 
												disabled={ disabledDateStart ? false : true }
												className="w-100"
												// defaultValue={ valuesEndDate ? moment(valuesEndDate) : '' } 
												placeholder="เลือกวันที่"
												onChange={(e) => this.onChangeValueDateEnd(e)}
												allowClear={false}
											/>
										)}
									</Form.Item>
								</Col> */}

								<Col xs={24} md={24} align={"right"} >
									<Button 
										type="primary" 
										className="ml-2 color-white" 
										htmlType="submit" 
									>
										ค้นหา
									</Button>
									{
										preLoadSubmit &&
										<Spin size="small" />
									}
								</Col>

							</Row>
						</Form>
					{/* </div> */}
					{/* <div className="px-5 py-1 card-bg-green"> */}
						<Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
							<Col xs={24} md={12} className="py-2">
								<strong className="color-red">
									รายการอนุมัติ
								</strong>
							</Col>
							<Col xs={24} md={12} className="pb-2" align="right">
								<Button 
									type="primary" 
									className="ml-2 color-white btn-green custom-export" 
									htmlType="submit" 
									onClick={this.fetchUrlWDHospitalApproverPDFReport}
								>
									<Icon type="file-text" /> รายงานสรุปเพื่อเตรียมจ่าย
								</Button>
								{/* <span style={{ fontSize:"13px" }}>
									จำนวนทั้งหมดของรายการอนุมัติ { dataTalbe.length }
								</span> */}
							</Col>
							<Col xs={ 24 } md={24} className="mb-4 mt-2">
								<Table
									locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
									dataSource={dataTalbe} 
									columns={columns} 
									loading={loading}
									scroll={{ x:"max-content", y: '550px' }}
									// pagination={{ pageSize: dataTalbe.length }}
									pagination={false}
								/>
							</Col>

							<Col xs={24} md={24} align={"center"}>
								<Button type="primary" className="mx-2 btn-white-red" htmlType="submit" onClick={this.submitReject}>
									ไม่อนุมัติ
								</Button>
								<Button type="primary" className="ml-2 color-white btn-green" htmlType="submit" onClick={this.submitApprover}>
									อนุมัติ
								</Button>
								{/* <Button type="primary" className="ml-2 color-white btn-gray" htmlType="submit" onClick={this.submitMoreinfo}>
									ขอเอกสารเพิ่มเติม
								</Button> */}
							</Col>
						</Row>
					</div>
				</div>
			</Container>
		)
	}
}

ConfirmCreate.defaultProps = {
	autoFocus: false
}

ConfirmCreate.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedConfirmCreate = Form.create()(ConfirmCreate)

export default withApollo(WrappedConfirmCreate)